import styled from "styled-components";

import Text from "../Text";

export const FilterWrap = styled.div`
  position: relative;
`;

export const FilterGroupBody = styled.div`
  padding: 4px 8px;
`;

export const FilterGroupHeader = styled.div`
  padding: 12px 0;
  display: flex;
  align-items: center;
  margin: 0 auto;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayscale};
  width: calc(100% - 32px);
`;

export const FilterGroupTitle = styled(Text).attrs({
  as: "h5",
  $type: "smallBold",
})`
  margin-right: auto;
`;
